export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      icon: 'ri-qr-scan-line',
      title: 'Quét Mã QR Đăng Ký',
      description: 'Quét mã QR hoặc điền form đăng ký với thông tin cơ bản của bạn',
      color: 'teal'
    },
    {
      number: '02',
      icon: 'ri-money-dollar-circle-line',
      title: 'Thanh Toán 70K',
      description: 'Thanh toán phí ưu đãi chỉ 70.000đ qua chuyển khoản hoặc ví điện tử',
      color: 'amber'
    },
    {
      number: '03',
      icon: 'ri-chat-smile-3-line',
      title: 'Tư Vấn & Thiết Kế',
      description: 'Đội ngũ chuyên gia tư vấn và thiết kế trang theo phong cách của bạn',
      color: 'rose'
    },
    {
      number: '04',
      icon: 'ri-rocket-2-line',
      title: 'Bàn Giao & Hỗ Trợ',
      description: 'Nhận trang hoàn chỉnh và được hỗ trợ kỹ thuật trong 30 ngày',
      color: 'teal'
    }
  ];

  const colorClasses = {
    teal: {
      bg: 'bg-teal-100',
      text: 'text-teal-600',
      gradient: 'from-teal-500 to-teal-600',
      border: 'border-teal-200'
    },
    amber: {
      bg: 'bg-amber-100',
      text: 'text-amber-600',
      gradient: 'from-amber-500 to-amber-600',
      border: 'border-amber-200'
    },
    rose: {
      bg: 'bg-rose-100',
      text: 'text-rose-600',
      gradient: 'from-rose-500 to-rose-600',
      border: 'border-rose-200'
    }
  };

  return (
    <section id="process" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-rose-100 rounded-full mb-6">
            <i className="ri-route-line text-lg text-rose-600"></i>
            <span className="text-sm font-semibold text-rose-700">Quy Trình Đơn Giản</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            4 Bước Đơn Giản Để Có<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-amber-600">
              Trang Thương Hiệu Cá Nhân
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Chỉ cần 4 bước đơn giản, bạn sẽ có ngay trang thương hiệu cá nhân chuyên nghiệp
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const colors = colorClasses[step.color as keyof typeof colorClasses];
            return (
              <div key={index} className="relative">
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-gray-300 to-transparent -translate-x-4"></div>
                )}
                <div className="bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-gray-200 transition-all duration-300 hover:shadow-2xl relative z-10">
                  <div className={`absolute -top-4 -right-4 w-16 h-16 flex items-center justify-center bg-gradient-to-br ${colors.gradient} rounded-xl shadow-lg`}>
                    <span className="text-2xl font-bold text-white">{step.number}</span>
                  </div>
                  <div className={`w-16 h-16 flex items-center justify-center ${colors.bg} rounded-xl mb-6`}>
                    <i className={`${step.icon} text-3xl ${colors.text}`}></i>
                  </div>
                  <h3 className="text-xl font-bold mb-4 text-gray-900">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-teal-50 to-amber-50 rounded-2xl border-2 border-teal-200">
            <i className="ri-time-line text-3xl text-teal-600"></i>
            <div className="text-left">
              <div className="text-sm text-gray-600">Thời gian hoàn thành</div>
              <div className="text-2xl font-bold text-gray-900">3-5 Ngày Làm Việc</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}